import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

/**
 * Asks after the drawing's last background AI reading. Answers
 * `{ job, floorplan }`: `job` is `{ id, status: 'running' | 'done',
 * result: { status, code, message } }` or null, and `floorplan` the row.
 * @param {string} projectId
 * @param {string} floorplanId
 */
export const getFloorplanAiReading = async (projectId, floorplanId) => {
  const apiPath = `projects/${projectId}/floorplans/${floorplanId}/ai-reading`;

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);
  return response.data;
};
